import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import style from './style/developability.scss';

/**
 * Renders an icon with a modifier class that matches the provided score, with a Tooltip on hover for the provided label
 *
 * @example
 * <Developability
 *     developabilityLabel={ 'this is the tooltip }
 *     developabilityScore={ '3' }
 * />;
 */
export default class Developability extends Component {
    render() {
        const { developabilityLabel, developabilityScore, classes } = this.props;

        const icon = <figure className={style[`developabilityIcon__${developabilityScore}`]} />;

        return <div className={ `${style.developability} ${classes.root}` }>
            { developabilityLabel
                ? <Tooltip
                    title={ developabilityLabel }
                    arrow
                    placement="top"
                    classes={{
                        tooltip: `${style.tooltip} ${classes.tooltip}`,
                        arrow: `${style.tooltipArrow} ${classes.tooltipArrow}`
                    }}
                >{ icon }
                </Tooltip>
                : icon }
        </div>;
    }
}

Developability.propTypes = {
    developabilityLabel: PropTypes.string,
    developabilityScore: PropTypes.string,
    classes: PropTypes.shape({
        root: PropTypes.string,
        tooltip: PropTypes.string,
        tooltipArrow: PropTypes.string,
    })
};

Developability.defaultProps = {
    classes: {
        root: '',
        tooltip: '',
        tooltipArrow: '',
    }
};
